'use client';
import { TypePageSkeleton } from '@fm-nx/contentful-types';
import { getLinkToForPage } from '@fm-nx/navigation';
import { usePathname } from 'next/navigation';
import { UrlObject } from 'url';

declare type Url = string | UrlObject;

const normalizePath = (path: string | Url | null) => {
    if (!path) return '';
    // eslint-disable-next-line no-nested-ternary
    const text = typeof path === 'string' ? path : path.pathname;
    // strip query params & trailing slashes
    return text ? text.replace(/\?.*/, '').replace(/\/$/, '') : text;
};

export const useNavigation = () => {
    const currentPath = usePathname();

    const linkTo = (page: TypePageSkeleton) => getLinkToForPage({ page });

    const isActive = (page: TypePageSkeleton) => {
        const active = normalizePath(currentPath);
        const target = normalizePath(linkTo(page).href);

        return target === active;
    };

    return { currentPath, linkTo, isActive };
};

export default useNavigation;
